// extracted by mini-css-extract-plugin
export default {"pageHeader":"OrderInfoContainer_pageHeader__cfMeE","customPayBtn":"OrderInfoContainer_customPayBtn__dR69-","btnContainer":"OrderInfoContainer_btnContainer__fy1rX"};